
import { Container, Box, Typography } from '@mui/material';

import Grid from '@mui/material/Grid';

import BotCard from './BotCard';
import type { BotCardProps } from '@/types';

interface Bot extends BotCardProps {
  id: string;
}

function Landing(): React.JSX.Element {
  const bots: Bot[] = [
    {
      id: 'voyager',
      title: 'Voyager',
      text: 'Search standards, SOPs, and DHFs with a real-time natural language chat interface.',
      link: '/voyager',
      image: '/img/voyager.svg',
    },
    {
      id: 'cartographer',
      title: 'Cartographer',
      text: `Generate structured reports tailored to your company's QMS format.`,
      link: '/cartographer',
      image: '/img/cartographer.svg',
      comingSoon: import.meta.env.VITE_STAGE === 'prod',
    },
    {
      id: 'quartermaster',
      title: 'Quartermaster',
      text: 'Handle document reviews, process upgrades, audits — all in one place.',
      link: '/quartermaster',
      image: '/img/quartermaster.svg',
    },
    // {
    //   id: 'qplus',
    //   title: 'Quartermaster+',
    //   text: 'Validate project documents against standards and best practices.',
    //   link: '/qplus',
    //   image: '/img/quartermaster_plus.svg',
    // },
    // {
    //   id: 'scribe',
    //   title: 'Scribe',
    //   text: 'Generate change control documentation and design specifications directly from your code',
    //   link: '/scribe',
    //   image: '/img/scribe.svg',
    //   comingSoon: true,
    // },
  ];

  return (
    <Box sx={{ display: 'flex', paddingTop: '10px' }}>
      <Container>
        <Grid container spacing={2} justifyContent='center' alignItems='center'>
          <Grid size={12}>
            <Typography variant='h4' gutterBottom align='center'>
              Welcome to the AccQsure<sup>&#174;</sup> Quality Knowledge Engine.
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography variant='body1' gutterBottom align='center'>
              Select an experience to get started.
            </Typography>
          </Grid>
          {bots.map((bot) => {
            return (
              <Grid
                key={bot.id}
                size={{ xs: 12, md: 6, lg: 6 }}
                {...({ align: 'center' } as any)}
              >
                <BotCard key={bot.id} {...bot} />
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default Landing;

